import React, { useState } from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const SupplierInfo = ({ supplier, language }) => {
  const [imageError, setImageError] = useState(false);

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <h2 className="text-xl font-heading font-semibold mb-6">
        {language === 'en' ? 'Supplier Information' : '供应商信息'}
      </h2>
      <div className="flex items-start gap-4 mb-6">
        <div className="w-16 h-16 rounded-lg overflow-hidden flex-shrink-0 bg-muted flex items-center justify-center">
          {!imageError && supplier?.logo ? (
            <Image
              src={supplier?.logo}
              alt={supplier?.logoAlt || supplier?.name}
              className="w-full h-full object-cover"
              onError={() => setImageError(true)}
            />
          ) : (
            <Icon name="Building2" size={32} color="var(--color-primary)" />
          )}
        </div>
        <div>
          <h3 className="font-heading font-semibold text-lg mb-1">{supplier?.name}</h3>
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Icon name="MapPin" size={14} />
            <span>{supplier?.location}</span>
          </div>
        </div>
      </div>
      <div className="space-y-4">
        <div className="flex items-start gap-3">
          <Icon name="Building2" size={18} color="var(--color-primary)" />
          <div>
            <p className="text-sm text-muted-foreground mb-1">
              {language === 'en' ? 'Company Type' : '公司类型'}
            </p>
            <p className="font-medium">{supplier?.type}</p>
          </div>
        </div>

        <div className="flex items-start gap-3">
          <Icon name="Calendar" size={18} color="var(--color-primary)" />
          <div>
            <p className="text-sm text-muted-foreground mb-1">
              {language === 'en' ? 'Established' : '成立时间'}
            </p>
            <p className="font-medium">{supplier?.established}</p>
          </div>
        </div>

        <div className="flex items-start gap-3">
          <Icon name="Mail" size={18} color="var(--color-primary)" />
          <div>
            <p className="text-sm text-muted-foreground mb-1">
              {language === 'en' ? 'Contact Email' : '联系邮箱'}
            </p>
            <p className="font-medium">{supplier?.email}</p>
          </div>
        </div>

        <div className="flex items-start gap-3">
          <Icon name="Phone" size={18} color="var(--color-primary)" />
          <div>
            <p className="text-sm text-muted-foreground mb-1">
              {language === 'en' ? 'Phone' : '电话'}
            </p>
            <p className="font-medium">{supplier?.phone}</p>
          </div>
        </div>
      </div>
      {supplier?.verified && (
        <div className="mt-6 pt-6 border-t border-border">
          <div className="flex items-center gap-2 text-success">
            <Icon name="ShieldCheck" size={20} />
            <span className="font-medium">
              {language === 'en' ? 'Verified Supplier' : '已验证供应商'}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default SupplierInfo;